import { Pipe, PipeTransform } from '@angular/core';

import { RegionCityWithZipCodeResponse } from '@app/api/marketplace/models';
import { DeliveryAvailabilityType } from '@app/delivery-mode/interfaces/delivery-availability-type.';

@Pipe({ name: 'toRegion' })
export class ToRegionPipe implements PipeTransform {
  transform(
    value?: Array<RegionCityWithZipCodeResponse> | null,
    region?: DeliveryAvailabilityType
  ) {
    if (value && value !== null && region) {
      return value
        .filter((zips) => zips.region === region)
        .map((value) => ({
          value: value.zipCode,
          name: value.city + ' ' + value.zipCode,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    } else return [];
  }
}
